import React from 'react';
import { View } from 'react-native';
import { SvgXml } from 'react-native-svg';

import tw from '../styles/tailwind';
import Text from './Text';

export default function SignatureView({
  xml,
  label = 'Firma de autorización',
  style,
}: {
  xml?: string | null;
  label?: string;
  style?: any;
}) {
  if (!xml) return null;

  return (
    <View style={[tw`mt-4`, style]}>
      <Text style={tw`text-gray-500 mb-2 font-500`}>{label}</Text>

      <View style={tw`bg-white border border-gray-200 rounded-xl p-3 h-40 items-center justify-center`}>
        <SvgXml xml={xml} width='100%' height='100%' />
      </View>
    </View>
  );
}
